import { EventOptions } from './events'

function getFullEventName<E extends string>(eventName: E, data: any) {
  if (eventName === 'action') {
    return `${eventName}/${data?.type || 'unknown'}`
  }

  return eventName
}
export default class TimeoutError<E extends string, T> extends Error {
  public eventName: E
  public timeout: number
  public options: EventOptions
  public data: T

  constructor(eventName: E, timeout: number, data: T, options = {}) {
    super(
      `Request for "${getFullEventName(
        eventName,
        data
      )}" timed out after ${timeout}ms..`
    )

    this.name = 'TimeoutError'
    this.eventName = eventName
    this.timeout = timeout
    this.data = data
    this.options = options
  }
}
